import IMerchantURLs from "./IMerchantURLs";

export default class MerchantURLs implements IMerchantURLs {
    constructor(
        public approvedRedirect?: string,
        public notificationEndpoint?: string,
        public rejectedRedirect?: string
    ) {}
}
